const TOKEN_SYMBOL_TO_ADDRESS = {
  SUSHI: "0xd4d42f0b6def4ce0383636770ef773390d85c61a",
  SPELL: "0x3e6648c5a70a150a88bce65f4ad4d506fe15d2af",
  gOHM: "0x8d9ba570d6cb60c7e3e0f31343efe75ab8e65fb1",
  MAGIC: "0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a"
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WMATIC;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WMATIC;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
  },
  NATIVE_TOKEN,
};
